const checkTmgaz = () => {
  if (typeof window === 'undefined') return false;
  return !!(
    window.location.origin.match(/tmgaz\.te\.ua/) ||
    window.location.search.match(/tmgaz/i) ||
    window.location.hostname.match(/tmgaz/i)
  );
};

const checkLocalhost = () => {
  if (typeof window === 'undefined') return false;
  return !!(
    window.location.origin.match(/localhost/) ||
    window.location.origin.match(/127\.0\.0\.1/)
  );
};

export default {
  state: {
    isTmgaz: checkTmgaz(),
    isLocalhost: checkLocalhost(),
  },
  getters: {
    isTmgaz: (state) => state.isTmgaz,
    isLocalhost: (state) => state.isLocalhost,
    logoImg: (state) => {
      return state.isTmgaz
        ? require('../../assets/tmgaz-logo.png')
        : require('../../assets/logo.png');
    },
    brandTitle: (state) => (state.isTmgaz ? 'Тернопільміськгаз' : 'Газпостач'),
    brandCode: (state) => (state.isTmgaz ? 'tmgaz' : 'gazpostach'),
  },
  mutations: {
    SET_IS_TMGAZ(state, value) {
      state.isTmgaz = !!value;
    },
  },
};
